componentRegistryInstance.register('checkbox', 'edit', 'hrd.components.form.CheckBoxComponent');

hrd.components.form.CheckBoxComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.CheckBoxComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, ''); // used to remove the class
		field.removeAttr('name'); // removed otherwise buttonset does not work ???????
		field.addClass('choice-group');
		var appearance = field.data('appearance') || 'checkbox';
		const checkboxTemplate = field.data('template');

		if (appearance === 'checkbox') {
			// need to add 'skip-layout' class because it can generate wrong widths during 'resize'
			let $composite = field.closest('.field-composite');
			$composite.addClass('skip-layout');
		}

		field.children('input').each((i, input) => {
			var $input = $(input);
			var newId = `${id}-${i}`;
			$input
				.attr('data-ignore', true)
				.attr('id', newId)
				.attr('name', `${id}-group`); // metto id del padre come parte del nome del gruppo
			var $label = $input.next();
			$label.prop('for', newId);
			//
			if (appearance === 'checkbox') {
				var $cnt = $(`<div class="choice-group-item"></div>`);
				$input.addClass('ignore-for-fhs choice-group-item-field').attr('data-type', 'choice-group-item');
				$label.addClass('ignore-aw');
				$cnt.append($input.detach()).append($label.detach()).appendTo(field);

				if (checkboxTemplate) {
					const $customInputContainer = $(`<div class="input-container ${checkboxTemplate}"></div>`);
					const $customInput = $(`<div class="checkbox"></div>`);

					$customInputContainer.append($input.detach()).append($customInput).prependTo($cnt);

					$customInput.off('.custom-input').on('click.custom-input', () => {
						$input.trigger('click');
					});
				}
			}
		})
	},
	getEditableField: function(field, name, object, options) {
		var list = [];
		$(':checkbox:checked', field).each((i, cb) => {
			list.push($(cb).val());
		});
		this.setValueByPath(object, name, list);
	},
	setEditableField: function(field, value, object, options) {
		var values = value || [];
		values.forEach(v => {
			$(`input[value="${v}"]`, field).prop('checked', true);
		});
	},
	resetEditableField: function(field, options) {
		$('input', field).prop('checked', false);
	}
});